import { MapperBase } from '../../utilities/mapper-base';
import { LexbeCase } from '../case.model';
import { CaseAccess } from '../ui/case-access.model';
import { AccountUser } from '../account-user.model';

export class LexbeCaseToCaseAccessMapper extends MapperBase<LexbeCase, CaseAccess> {
	map(source: LexbeCase, users: AccountUser[]): CaseAccess {
		const dest = new CaseAccess();
		dest.caseId = source.caseId;
		dest.caseName = source.caseName;
		dest.accountId = source.accountId;
		dest.dateTimeCreated = source.dateTimeCreated;
		dest.simpleCaseId = source.simpleCaseId;
		dest.accessibleUsers = users.filter(x => x.caseIds.includes(source.caseId));
		return dest;
	}

}

